let List = () => import (/* webpackChunkName: "cadastros/ordens-servicos" */ '../pages/cadastros/OrdensServicos');
let New = () => import (/* webpackChunkName: "cadastros/ordem-servico" */ '../pages/cadastros/OrdemServico');

export const OrdemServico = {
    List, New
};
